import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "template-storage-example" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "error-message"
}
const _hoisted_9 = {
  key: 2,
  class: "error-message"
}
const _hoisted_10 = {
  key: 3,
  class: "error-message"
}
const _hoisted_11 = { class: "section" }
const _hoisted_12 = {
  key: 0,
  class: "loading"
}
const _hoisted_13 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_14 = {
  key: 2,
  class: "templates-table"
}
const _hoisted_15 = { class: "actions" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "section" }
const _hoisted_19 = {
  key: 0,
  class: "loading"
}
const _hoisted_20 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_21 = {
  key: 2,
  class: "template-details"
}
const _hoisted_22 = { class: "metadata" }
const _hoisted_23 = { class: "metadata-item" }
const _hoisted_24 = { class: "metadata-item" }
const _hoisted_25 = { class: "metadata-item" }
const _hoisted_26 = { class: "metadata-item" }
const _hoisted_27 = { class: "metadata-item" }
const _hoisted_28 = { class: "metadata-item" }
const _hoisted_29 = { class: "metadata-item" }
const _hoisted_30 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[21] || (_cache[21] = _createElementVNode("h1", null, "Template Storage Example", -1)),
    _createElementVNode("section", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", null, "1. Upload Template", -1)),
      (!_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " You are not authenticated. Please log in to upload templates. "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "file-upload" }, "Select Excel Template:", -1)),
        _createElementVNode("input", {
          type: "file",
          id: "file-upload",
          accept: ".xlsx,.xls",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args)))
        }, null, 32)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "template-name" }, "Template Name:", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "template-name",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.templateName) = $event)),
          placeholder: "Enter template name"
        }, null, 512), [
          [_vModelText, _ctx.templateName]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { for: "template-description" }, "Description:", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "template-description",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.templateDescription) = $event)),
          placeholder: "Enter template description"
        }, null, 512), [
          [_vModelText, _ctx.templateDescription]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.uploadTemplate && _ctx.uploadTemplate(...args))),
        disabled: !_ctx.selectedFile || !_ctx.templateName || _ctx.loading || !_ctx.isAuthenticated,
        class: "btn btn-primary"
      }, _toDisplayString(_ctx.loading ? 'Uploading...' : 'Upload Template'), 9, _hoisted_7),
      (!_ctx.selectedFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Please select a file to upload. "))
        : _createCommentVNode("", true),
      (!_ctx.isAuthenticated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Please log in to upload templates. "))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error.message), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_11, [
      _cache[12] || (_cache[12] = _createElementVNode("h2", null, "2. My Templates", -1)),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.loadTemplates && _ctx.loadTemplates(...args))),
        class: "btn btn-secondary"
      }, " Refresh Templates "),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Loading templates..."))
        : (_ctx.templates.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " No templates found. Upload a template to get started. "))
          : (_openBlock(), _createElementBlock("table", _hoisted_14, [
              _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Name"),
                  _createElementVNode("th", null, "Description"),
                  _createElementVNode("th", null, "Status"),
                  _createElementVNode("th", null, "Uploaded"),
                  _createElementVNode("th", null, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (template) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: template.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(template.name), 1),
                    _createElementVNode("td", null, _toDisplayString(template.description), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass('status-badge status-' + template.status)
                      }, _toDisplayString(template.status), 3)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(template.created_at)), 1),
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.downloadTemplate(template.id)),
                        class: "btn btn-sm"
                      }, " Download ", 8, _hoisted_16),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.deleteTemplate(template.id)),
                        class: "btn btn-sm btn-danger"
                      }, " Delete ", 8, _hoisted_17)
                    ])
                  ]))
                }), 128))
              ])
            ]))
    ]),
    _createElementVNode("section", _hoisted_18, [
      _cache[20] || (_cache[20] = _createElementVNode("h2", null, "3. Latest Template", -1)),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.loadLatestTemplate && _ctx.loadLatestTemplate(...args))),
        class: "btn btn-secondary"
      }, " Get Latest Template "),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Loading latest template..."))
        : (!_ctx.selectedTemplate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, " No template selected. Click \"Get Latest Template\" to load the most recent template. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.selectedTemplate.name), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.selectedTemplate.description), 1),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Status:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTemplate.status), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[14] || (_cache[14] = _createElementVNode("strong", null, "File Type:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTemplate.file_type), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[15] || (_cache[15] = _createElementVNode("strong", null, "File Size:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatFileSize(_ctx.selectedTemplate.file_size)), 1)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Original Filename:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTemplate.original_filename), 1)
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Uploaded:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.selectedTemplate.created_at)), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Last Accessed:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.selectedTemplate.last_accessed)), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _cache[19] || (_cache[19] = _createElementVNode("strong", null, "Access Count:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.selectedTemplate.access_count), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.downloadTemplate(_ctx.selectedTemplate.id))),
                  class: "btn btn-primary"
                }, " Download Template ")
              ])
            ]))
    ])
  ]))
}